<div class="x-section" data-test-id="ruecklauf-root" data-help-anchor="_dashboard_ruecklauf">
	<div class="x-section__headline">
		<i class="material-icons" aria-hidden="true">settings_backup_restore</i>
		<h2 class="mat-h1 margin-right-auto" tabindex="0">{{ headline }}</h2>
	</div>
	<div class="x-section__subline"></div>
	<div class="x-section__main">
		@if (vorgaenge) {
			<ul class="c-list focus-list-inwards-dark">
				@for (vorgang of vorgaenge; track vorgang) {
					<li class="c-list__item focus-inwards-dark" data-test-id="eintrag">
						<a class="c-list__link vorgang-link" data-test-id="eintrag-link" (click)="goToVorgang(vorgang)"
						   (keyup.enter)="goToVorgang(vorgang)" tabindex="0">
							<div class="c-row c-row--header c-wrap">
								<schir-int-client-aktenzeichen
										data-test-id="aktenzeichen"
										class="c-row__item c-row__item--header"
										[aktenzeichen]="vorgang.aktenzeichen"
										[verfahrenId]="getIdNumber(vorgang, VorgangLinkRel.VERFAHREN)"
								/>
								<span class="c-row__item c-row__item--secondary"
								      data-test-id="vorgang-status">{{ vorgang.status | enumToLabel: vorgangStatusLabel }}</span>
							</div>
							<div class="c-row c-wrap">
								<span class="c-row__item" data-test-id="vorgang-typ">{{ vorgang.typ | enumToLabel: vorgangsTypen }}</span>
								<span class="c-row__item" data-test-id="vorgang-datum">{{ vorgang.ruecklaufDatum | formatDate }}</span>
							</div>
							<div class="c-row c-row--secondary">
								<span class="c-row__item" data-test-id="vorgang-notiz">{{ vorgang.notiz }}</span>
							</div>
							@if (vorgang.standortAkte) {
								<div class="c-row c-row--secondary">
									<span class="c-row__item" data-test-id="vorgang-standortAkte">Standort Akte: {{ vorgang.standortAkte }}</span>
								</div>
							}
						</a>
						<div class="c-button-bar c-button-bar--overlay">
							<schir-int-client-button-round data-test-id="open-status-dialog-button"
							                               (click)="openStatusDialog(vorgang)"
							                               popup="dialog" materialIcon="send"
							                               toolTip="Status des Vorgangs setzen"
							                               cssClass="focus-inwards-dark"/>
						</div>
					</li>
				}
			</ul>
		}
	</div>
</div>
